import React from 'react';
import { useParams } from 'react-router-dom';
import { formatDocumentType } from 'utils';
import { Breadcrumb } from 'components';
import DocumentsContext from './DocumentsContext';

const DocumentsBreadcrumb: React.FC = () => {
  const { documentId } = useParams<Record<string, string>>();
  const { listing, documentsToView } = React.useContext(DocumentsContext);

  const getActivePageDocType = () => {
    if (!documentId) return null;
    if (documentId === 'all') return 'Listing Paperwork';
    return formatDocumentType(documentsToView[0].documentType);
  };

  const routes = [
    {
      breadcrumbName: `${listing.line1} ${listing.line2 || ''}`,
      path: `/listing/${listing.id}/view`,
    },
    {
      breadcrumbName: 'Documents',
      path: documentId ? `/../documents` : undefined,
    },
  ];

  const activePageDocType = getActivePageDocType();
  if (activePageDocType) {
    routes.push({
      breadcrumbName: activePageDocType,
      path: undefined,
    });
  }

  return <Breadcrumb routes={routes} />;
};

export default DocumentsBreadcrumb;
